__turbopack_context__.v({
  "colorify-fill": "VNTYlq_colorify-fill",
  "colorify-stroke": "VNTYlq_colorify-stroke",
});
